import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {updateContent} from '../../../../../services/api/apiReGenerateLabel'
import {message} from "antd"
import PubSub from "pubsub-js"

class NoteColumnPopup extends Component {
    state = {
        note: this.props.note,
        loading: false,
        error: ''
    }

    _handleChange = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
    }

    _handleUpdate = async (e) => {
        e.preventDefault()
        this.setState({
            error: '',
            loading: true
        })

        try {
            const {id, onTogglePopup} = this.props
            const {note} = this.state
            const payload = {
                note
            }

            const {data: respons} = await updateContent(id, payload)
            const {success: successApi, message: error} = respons

            if (!successApi) return this.setState({
                error,
                loading: false
            })

            onTogglePopup()
            PubSub.publish('LIST_RE_GENERATE')
            message.success('Cập nhật Ghi chú thành công!')
        } catch (err) {
            this.setState({
                error: err.message,
                loading: false
            })
        }
    }

    render() {
        const {note, error, loading} = this.state
        const {isOpen, onTogglePopup} = this.props

        return <Modal isOpen={isOpen} toggle={onTogglePopup}>
            <ModalHeader toggle={onTogglePopup}>Sửa ghi chú</ModalHeader>
            <ModalBody>
                <label className="font-weight-bold">Ghi chú</label>
                <textarea rows={5} className="form-control" name="note" onChange={this._handleChange} value={note}/>

                {
                    error && <div className="text-danger mt-3">{error}</div>
                }
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
                <button disabled={loading} className="btn btn-secondary" color="secondary" onClick={onTogglePopup}>Hủy
                </button>
                <button disabled={loading} onClick={this._handleUpdate} className="btn btn-primary">
                    Cập nhật
                </button>
            </ModalFooter>
        </Modal>
    }
}

NoteColumnPopup.propTypes = {
    id: PropTypes.string.isRequired,
    note: PropTypes.string,
    onTogglePopup: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
}

export default NoteColumnPopup